import { useEffect, useCallback } from 'react'
import { RootState, useAppDispatch, useAppSelector } from '../../redux/store'
import { fetchAssignedTaskDetails, FetchAssignedTaskDetailsPayload } from '../../redux/task/actions'

const useFetchAssignedTaskDetails = (
  payload: FetchAssignedTaskDetailsPayload,
  refreshTrigger?: number,
) => {
  const dispatch = useAppDispatch()
  const { errorAssignTask, assignedTask, loadingAssignTask } = useAppSelector(
    (state: RootState) => state.task,
  )

  const fetchData = useCallback(async () => {
    if (payload.teamMemberWorkdayId) {
      await dispatch(fetchAssignedTaskDetails(payload))
    }
  }, [dispatch, payload])

  useEffect(() => {
    fetchData()
  }, [fetchData, refreshTrigger])

  return { tasks: assignedTask, loadingAssignTask, error: errorAssignTask }
}

export default useFetchAssignedTaskDetails
